import { useNavigate, useLocation } from "react-router-dom";
import {
  FaHome,
  FaGraduationCap,
  FaFlask,
  FaChartBar,
  FaLandmark,
  FaArrowRight,
  FaPrint,
} from "react-icons/fa";
import { useEffect, useState } from "react";


import BSCForm from "./Form2";
import BCOMForm from "./Form3";
import AdmissionForm from "./AdmissionForm";
import { useSelector } from "react-redux";

const AdmissionHomePage = () => {
  const { isLoggedIn, userData, loginModale } = useSelector(
    (state) => state.auth,
  );
  const navigate = useNavigate();
  const location = useLocation();
  const currentPath = location.pathname;

  const [selectedForm, setSelectedForm] = useState(null);
  const [showCourseSelector, setShowCourseSelector] = useState(true);

  const handleFormSelection = (formType, part) => {
    console.log(formType, part);
    setSelectedForm(formType);
    window.location.href="/admission/"+formType+"/"+part;
        // navigate(`/admission/${formType}/${part}`, { replace: false });
    // setShowCourseSelector(false);
  };

  const renderForm = () => {
    const formFromPath = currentPath.split("/");
    const path = formFromPath.pop();

    switch (path) {
      case "BA":
        return <AdmissionForm />;
      case "BCOM":
        return <BCOMForm />;
      case "BSC":
        return <BSCForm />;
      default:
        return null;
    }
  };

 
  const goBackToSelection = () => {
    setSelectedForm(null);
    setShowCourseSelector(true);
    navigate("/admission-form", { replace: false });
  };

 
  const isCurrentYearAdmission = (admission) => {
    if (!admission) return false;
    const admissionYear = new Date(admission.created_at).getFullYear();
    const currentYear = new Date().getFullYear();
    return admissionYear === currentYear;
  };

  
  const isPreviousYearAdmission = (admission) => {
    if (!admission) return false;
    const admissionYear = new Date(admission.created_at).getFullYear();
    const currentYear = new Date().getFullYear();
    return admissionYear < currentYear;
  };


  const getStudentStatus = () => {
    const admissions = userData?.admissions || [];
    
    if (admissions.length === 0) {
      return 'NEW_STUDENT';
    }
    
   
    const latestAdmission = admissions[admissions.length - 1];
    
    if (isCurrentYearAdmission(latestAdmission)) {
    
      return 'CURRENT_YEAR_ADMITTED';
    }
    
    if (isPreviousYearAdmission(latestAdmission)) {
    
      return 'PREVIOUS_YEAR_STUDENT';
    }
    
    return 'NEW_STUDENT';
  };

  const studentStatus = getStudentStatus();
  const admissions = userData?.admissions || [];
  const latestAdmission = admissions.length > 0 ? admissions[admissions.length - 1] : null;

  const courses = [
    {
      id: "BA",
      courseName: "ba",
      icon: <FaLandmark />,
      courseCode: "1",
      title: "Bachelor of Arts",
      description: "Admission form for Bachelor of Arts",
      applyText: "Apply for Bachelor of Arts",
      color: "#1a365d",
      bgColor: "#ebf0f8",
    },
    {
      id: "BSC",
      icon: <FaFlask />,
      courseCode: "2",
      courseName: "bsc",
      title: "Bachelor of Science",
      description: "Admission form for Bachelor of Science",
      applyText: "Apply for Bachelor of Science",
      color: "#ff4646",
      bgColor: "#e8f5ee",
    },
    {
      id: "BCOM",
      courseCode: "3",
      icon: <FaChartBar />,
      courseName: "bcom",
      title: "Bachelor of Commerce",
      description: "Admission form for Bachelor of Commerce",
      applyText: "Apply for Bachelor of Commerce",
      color: "#3d3d6b",
      bgColor: "#eeeef7",
    },
  ];

 
  const getCourseByCode = (courseCode) => {
    return courses.find(course => course.courseCode === courseCode);
  };


  const getPartForStudent = () => {
    if (!latestAdmission) return null;
    
   
    if (admissions.length === 1) {
      return "part-2";
    }
   
    else if (admissions.length === 2) {
      return "part-3";
    }
    return null;
  };

  
  const renderPrintButton = () => {
    return (
      <div className="course-selection">
        <div className="admission-complete-card">
          <div className="success-icon">
            <FaGraduationCap />
          </div>
          <h3>Admission Submitted</h3>
          <p>You have already submitted your admission form for {latestAdmission?.part == 1 ? "First Year" : latestAdmission?.part == 2 ? "Second Year" :"N/A" }</p>
          <p className="admission-details">
            <strong>Course:</strong> {getCourseByCode(latestAdmission?.course)?.title || 'N/A'}
            <br />
            <strong>URN:</strong> {latestAdmission?.urn || 'N/A'}
            <br />
            <strong>Year:</strong>{latestAdmission?.part == 1 ? "First Year" : latestAdmission?.part == 2 ? "Second Year"  : "N/A"}
          </p>
          <a 
            className="print-btn"
            target="_blank"
            href={`/admission-form/print/${latestAdmission?.admission_code}`}
           
          >
            <FaPrint /> Download/Print Admission Form
          </a>
        </div>
      </div>
    );
  };


  const renderNewStudentCourses = () => {
    return (
      <>
        <div className="course-selection">
          <p onClick={() => console.log(userData)} className="section-subtitle">
            <FaGraduationCap className="subtitle-icon" />
            Choose your program for 1st Year Admission
          </p>
        </div>
        <div className="course-grid">
          {courses.map((course) => (
            <div
              key={course.id}
              className="course-card"
              onClick={() => handleFormSelection(course.courseName, "part-1")}
            >
              <div
                className="course-card-header"
                style={{ backgroundColor: course.color }}
              >
                <span className="course-icon">{course.icon}</span>
                <span className="course-title">{course.title}</span>
              </div>
              <div className="course-card-body">
                <p className="course-description">{course.description}</p>
                <div
                  className="apply-btn Admission-button"
                  style={{ color: course.color }}
                >
                  {course.applyText}
                  <FaArrowRight className="arrow-icon" />
                </div>
              </div>
            </div>
          ))}
        </div>
      </>
    );
  };


  const renderReturningStudentCourses = () => {
    if (!latestAdmission) return null;
    
    const studentCourse = getCourseByCode(latestAdmission.course);
    if (!studentCourse) return null;

    const part = getPartForStudent();
    if (!part) return null;

    const partLabel = admissions.length === 1 ? '2nd Year' : '3rd Year';

    return (
      <>
        <div className="course-selection">
          <p onClick={() => console.log(userData)} className="section-subtitle">
            <FaGraduationCap className="subtitle-icon" />
            Continue {partLabel} Admission Form
          </p>
          <p className="student-info">
            <strong>Your Course:</strong> {studentCourse.title}
            <br />
            <strong>URN:</strong> {latestAdmission.urn}
          </p>
        </div>
        <div className="course-grid">
          <div
            key={studentCourse.id}
            className="course-card"
            onClick={() => handleFormSelection(studentCourse.courseName, part)}
          >
            <div
              className="course-card-header"
              style={{ backgroundColor: studentCourse.color }}
            >
              <span className="course-icon">{studentCourse.icon}</span>
              <span className="course-title">{studentCourse.title}</span>
            </div>
            <div className="course-card-body">
              <p className="course-description">{studentCourse.description}</p>
              <div
                className="apply-btn Admission-button"
                style={{ color: studentCourse.color }}
              >
                Continue {partLabel} Admission
                <FaArrowRight className="arrow-icon" />
              </div>
            </div>
          </div>
        </div>
      </>
    );
  };

  return (
    <div className="admission-content">
      {studentStatus === 'NEW_STUDENT' && renderNewStudentCourses()}
      
      {studentStatus === 'CURRENT_YEAR_ADMITTED' && renderPrintButton()}
      
      {studentStatus === 'PREVIOUS_YEAR_STUDENT' && renderReturningStudentCourses()}
    </div>
  );
};

export default AdmissionHomePage;